
    import { computed, defineComponent, ref } from 'vue'
    import { useSparePartFilterStore } from '@/store/sparePartFilter'
    import { useBrowserStateStore } from '@/store/browserState'
    import { buildLocalization } from '@/util'

    import { Card, CardHeader, CardTitle, CardBody } from '@progress/kendo-vue-layout'
    import SearchBySn from './search-by-sn.vue'
    import SearchByPartNumber from './search-by-part-number.vue'
    import SearchByProductModel from './search-by-product-model.vue'
    import BrowseSparePartCatalog from './browse-spare-part-catalog.vue'
    import ScrollArrows from '@/components/common/scroll-arrows.vue'

    export default defineComponent({
        name: 'SparePartSearch',

        components: {
            Card,
            CardHeader,
            CardTitle,
            CardBody,
            SearchBySn,
            SearchByPartNumber,
            SearchByProductModel,
            BrowseSparePartCatalog,
            ScrollArrows
        },

        setup() {
            const browserState = useBrowserStateStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const pageRef = ref<HTMLElement | null>(null)
            const modelCardRef = ref<InstanceType<typeof Card> | null>(null)
            const publicData = { pageRef, modelCardRef }

            /********************************************************************************************************************
             COMPUTED PROPERTIES
             ********************************************************************************************************************/
            const isSmallScreen = computed(() => browserState.isSmallScreen)
            const computedData = { isSmallScreen }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            const publicMethods = { localize }

            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const sparePartFilterStore = useSparePartFilterStore()
            sparePartFilterStore.resetAll()

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return {
                // DATA
                ...publicData,
                // COMPUTED
                ...computedData,
                // METHODS AND EVENT HANDLERS
                ...publicMethods
            }
        }
    })

